module.exports = __webpack_public_path__ + "static/media/right-arrow.e525ce86.svg";